import { CURRENT_ACTIONS_QUEUE_DATA, SAVE_ACTIONS_QUEUE_END, SAVE_ACTIONS_QUEUE_START } from "constants/ActionsTypes";
import { COMMON_TASK_ACTION, END_TASK_ACTION, getActionsQueue, ISSUE_ACTION, removeActionFromQueue, RESET_ACTION, COACHING_ACTION, SWAP_ACTION, SET_TASKS_ORDER } from "util/ActionsQueueManager";
import { addCommonTask, endTask, fetchCurrentTask, resetCurrentTask, setofficerpreferedtasksforunit, swapTask } from "./Tasks";
import { addcommontaskIssue } from "./Issues";
import { addcommontaskCoaching } from "./Coachings";

export const saveQueue = () => {
    return async (dispatch) => {
        const actionsQueue = getActionsQueue();
        if (actionsQueue.length === 0) {
            return;
        }
        dispatch({ type: SAVE_ACTIONS_QUEUE_START });
        try {
            for (const action of actionsQueue) {
                switch(action.action) {
                    case COMMON_TASK_ACTION:
                        await dispatch(addCommonTask(action.params.commonTask, action.params.runningTimer, action.time));
                        break;
                    case SWAP_ACTION:
                        await dispatch(swapTask(action.params.toRunningTimer, action.time));
                        break;
                    case END_TASK_ACTION:
                        await dispatch(endTask(action.params.task, action.params.start, action.params.runningTimer, action.time));
                        break;
                    case ISSUE_ACTION:
                        await dispatch(addcommontaskIssue(action.params, action.time));
                        break;
                    case COACHING_ACTION:
                        await dispatch(addcommontaskCoaching(action.params, action.time));
                        break;
                    case RESET_ACTION:
                        await dispatch(resetCurrentTask(action.params.runningTimer, action.time));
                        break;
                    case SET_TASKS_ORDER:
                        await dispatch(setofficerpreferedtasksforunit(action.params.unitId, action.params.tasksOrder, action.time));
                        break;
                    default:
                        // Unhandle action
                        removeActionFromQueue(action.action, action.time);
                }
            };
            dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: 0 });
        } catch (e) {
            console.log("Error during save actions****:", e);
        } finally {
            dispatch(fetchCurrentTask());
            dispatch({ type: SAVE_ACTIONS_QUEUE_END });
        }
    }
};